import { Component, Input } from '@angular/core'

import { ScopeElementsConfig } from '../models'
import { isPreferenceActive } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'

@Component({ selector: 'scope-departments-header', templateUrl: './departments-header.component.html' })
export class DepartmentsHeaderComponent {
  @Input() config: ScopeElementsConfig
  @Input() level: number

  protected readonly isPreferenceActive = isPreferenceActive
}
